import {FC} from 'react';
import {Button, theme} from 'thermia-react-container';
import {useIsAdmin} from "../hooks/useIsAdmin";
import {OnBehalfOfService} from "../service/onBehalfOfService";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useRefreshData} from "../pages/registration/hooks/useRefreshData";


const OnBehalfOfNotice: FC = () => {
  const isAdmin = useIsAdmin();
  const navigate = useNavigate();
  const refreshData = useRefreshData()
  const { t } = useTranslation('registrations');

  const reset = () => {
    OnBehalfOfService.reset();
    refreshData();
    navigate('/admin');
  };
  
  return isAdmin && OnBehalfOfService.partner && (
    <>
      <div
        style={{ 
          backgroundColor: theme.palette.warning.main,
          padding: 10, 
          paddingBottom: 7, 
          paddingTop: 130, 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          textAlign: 'center', 
          fontSize: '15px', 
          textTransform: 'uppercase',
          zIndex: 10,
      }}
      data-partnerid={OnBehalfOfService.partner?.id}
      >{t('registrations.admin.actingOnBehalfOf', { customerId: OnBehalfOfService.partner?.customerId, companyName: OnBehalfOfService.partner?.companyName, market: OnBehalfOfService.partner?.salesArea?.market })}</div>

      <Button
        title={t('registrations.admin.stopActingOnBehalfOf')}
        variant={'contained'}
        style={{ background: 'white', color: '#333', paddingTop: 8, position: 'fixed', top: '128px', right: '7px', height: 25, opacity: .9, fontSize: 13, zIndex: 11 }}
        onClick={reset} 
      />
      <div style={{ height: 10 }}></div>
    </>
  );
};

export default OnBehalfOfNotice;
